export default {
  namespaced: true,
  state: {
      loading: false
  },
  getters:{

  },
  actions: {
      show({ commit }) {
        //   console.log("Loading...")
          commit("show");
      },
      hide({ commit }) {
          commit("hide");
      }
  },
  mutations: {
      show(state) {
          state.loading = true;
      },
      hide(state) {
          state.loading = false;
      }
  }
};